import { getUser, setUser } from './base/auth';
import { http } from './base/http';
import type { OrganizationUserResponse, User } from './types/user';

export const UserAPIs = {
    async getCurrentUser(refetch = false): Promise<User> {
        let user = getUser();
        if (user && !refetch) {
            return user;
        }
        user = await http.get<User>('/users/current');
        setUser(user);
        return user;
    },
    async updateUser(
        firstName: string | null,
        last_name: string | null,
        email: string | null,
        picture: File | null,
        onUpdated: () => void,
    ): Promise<void> {
        const user = await this.getCurrentUser();
        const updates = new FormData();

        if (firstName) {
            updates.append('first_name', firstName);
        }
        if (last_name) {
            updates.append('last_name', last_name);
        }
        if (email) {
            updates.append('email', email);
        }
        if (picture) {
            updates.append('profile_picture', picture);
        }
        http.upload(`/users/${user.id}`, 'PATCH', updates, () => {}, onUpdated);
    },
    async getOrganizationUsers(): Promise<OrganizationUserResponse> {
        const user = getUser();
        return http.get<OrganizationUserResponse>('/organization_users');
    },
    async updateUserType(userId: number, type: string): Promise<void> {
        return http.patch(`/organization_users/${userId}/update_type`, { user_type: type });
    },
    async deleteUser(userId: number): Promise<void> {
        return http.delete(`/organization_users/${userId}`);
    },
};
